import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// Opciones en peso normal; en negrita solo las que agrupan a las demás (p. ej. «Seleccionar todo»)
const CheckButtonStyled = styled.div`
  .MuiFormControlLabel-label {
    font-family: ${tokens.typography.fontFamily.primary};
    font-style: normal;
    font-weight: ${props => (props.$strong ? 600 : 400)};
    font-size: 14px;
    line-height: 21px;
    color: ${tokens.color.text.secondary};
  }
`

export default CheckButtonStyled
